import {HTTP_METHODS} from '../httpMethods'
import {toSafePathSegment, toSafeQueryString} from '@/utils/security/pathSafety'

export const PRODUCT_COMBO_CONFIG = {
  SAVE_PRODUCT_COMBO: {
    endPoint: 'combo-product',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
    headers: {
      scope: 'pepsi',
    },
  },

  CHECK_NAME_UNIQUE: name => ({
    endPoint: `combo-product/validate-name?${new URLSearchParams({name: String(name ?? '')}).toString()}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
  }),

  GET_COMBO_PRODUCT_PROMOTION: comboProductId => {
    const safeId = String(comboProductId ?? '').trim()
    toSafePathSegment(safeId)

    return {
      endPoint: `promotion?${toSafeQueryString({comboProductId: safeId})}`,
      baseUrlKey: 'inventoryApiUrl',
      method: HTTP_METHODS.GET,
    }
  },

  DELETE_COMBO_PRODUCT: comboProductId => ({
    endPoint: `combo-product/${toSafePathSegment(comboProductId)}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.DELETE,
  }),
}
